import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
export const PageLoader = () => {
    return (
        <div className="flex h-screen w-screen items-center justify-center">
            <Spin className="h-16 w-16 text-dark" indicator={<LoadingOutlined style={{ fontSize: 24 }} />} />
        </div>
    )
}